// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rOnZ","title":"styles_title__60Ldu"};